/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SelectionType {
  All = "All",
  Partial = "Partial",
}

export enum RejectCommentReasonType {
  Inventory = "Inventory",
  Guide = "Guide",
  Price = "Price",
  ReceiveOrder = "ReceiveOrder",
}

export enum PublicationStatus {
  NotChecked = "NotChecked",
  Published = "Published",
  PublishedWithoutPhoto = "PublishedWithoutPhoto",
  Rejected = "Rejected",
}

export enum PlpBannerType {
  PartnershipDevelopment = "PartnershipDevelopment",
  Sales = "Sales",
  Marketing = "Marketing",
  Commercial = "Commercial",
}

export enum PageElementType {
  Header = "Header",
  PopUp = "PopUp",
}

export enum PageElementDisplayStatus {
  Active = "Active",
  Inactive = "Inactive",
  Expired = "Expired",
}

export enum ImageType {
  PlpBanner = "PlpBanner",
  ProductList = "ProductList",
  Banner = "Banner",
  CarouselBrand = "CarouselBrand",
  CarouselText = "CarouselText",
  CarouselIcon = "CarouselIcon",
  BannerTile = "BannerTile",
  CarouselBig = "CarouselBig",
  CarouselMedium = "CarouselMedium",
  MobileCarouselDesktopTile = "MobileCarouselDesktopTile",
  Story = "Story",
  Header = "Header",
  CountDown = "CountDown",
  Video = "Video",
  Text = "Text",
  Button = "Button",
  Comment = "Comment",
  Popup = "Popup",
  Seo = "Seo",
  TextStory = "TextStory",
  SmallBanner = "SmallBanner",
  BrandLogo = "BrandLogo",
  Testimonial = "Testimonial",
  ProductListItem = "ProductListItem",
}

export enum ImageFormat {
  Png = "Png",
  Jpg = "Jpg",
  Jpeg = "Jpeg",
  Svg = "Svg",
  Webp = "Webp",
  Gif = "Gif",
}

export enum DeviceType {
  Mobile = "Mobile",
  Desktop = "Desktop",
}

export enum ConditionType {
  Hour = "Hour",
  Minute = "Minute",
  Second = "Second",
  Percent = "Percent",
}

export enum ComponentType {
  PlpBanner = "PlpBanner",
  ProductList = "ProductList",
  Banner = "Banner",
  CarouselBrand = "CarouselBrand",
  CarouselText = "CarouselText",
  CarouselIcon = "CarouselIcon",
  BannerTile = "BannerTile",
  CarouselBig = "CarouselBig",
  CarouselMedium = "CarouselMedium",
  MobileCarouselDesktopTile = "MobileCarouselDesktopTile",
  Story = "Story",
  Header = "Header",
  CountDown = "CountDown",
  Video = "Video",
  Text = "Text",
  Button = "Button",
  Comment = "Comment",
  Popup = "Popup",
  Seo = "Seo",
  TextStory = "TextStory",
  SmallBanner = "SmallBanner",
  Testimonial = "Testimonial",
  CarouselVideo = "CarouselVideo",
}

export enum ComponentDisplayType {
  BannerTile = "BannerTile",
  BannerTileWithText = "BannerTileWithText",
}

export enum ComponentDisplayStatus {
  Active = "Active",
  Inactive = "Inactive",
  Expired = "Expired",
  Unpublished = "Unpublished",
}

export enum ComponentDesignType {
  SolidColor = "SolidColor",
  PinkBox = "PinkBox",
  Image = "Image",
}

export enum ClientDeviceType {
  Mobile = "Mobile",
  Desktop = "Desktop",
}

export enum ButtonDesignType {
  Filled = "Filled",
  Outline = "Outline",
}

export enum BusinessType {
  Pd = "Pd",
  Sales = "Sales",
  Marketing = "Marketing",
  Commercial = "Commercial",
  Beauty = "Beauty",
  Health = "Health",
  Electric = "Electric",
  Fragrance = "Fragrance",
  Accessory = "Accessory",
}

export enum BannerComponentType {
  Large = "Large",
  Small = "Small",
}

export type ActionResult = object;

export interface ActionResultSuccessEnvelop {
  isSuccess?: boolean;
  data?: XmlSitemapResult | null;
}

export type AddBannerComponentRequest = ComponentBaseRequest & {
  type?: BannerComponentType;
};

export type AddBannerTileComponentRequest = ComponentBaseRequest & {
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
  displayType?: ComponentDisplayType;
};

export type AddCarouselBigComponentRequest = ComponentBaseRequest & object;

export type AddCarouselBrandComponentRequest = ComponentBaseRequest & object;

export type AddCarouselIconComponentRequest = ComponentBaseRequest & object;

export type AddCarouselMediumComponentRequest = ComponentBaseRequest & object;

export type AddCarouselTextComponentRequest = ComponentBaseRequest & object;

export type AddCarouselVideoRequest = ComponentBaseRequest & object;

export type AddMobileCarouselDesktopTileComponentRequest =
  ComponentBaseRequest & object;

export type AddProductListComponentRequest = ComponentBaseRequest & {
  backgroundColor?: string | null;
  designType?: ComponentDesignType;
  subTitle?: string | null;
  /** @format uri */
  mobileImageUri?: string | null;
  /** @format uri */
  desktopImageUri?: string | null;
  showTitleAndSubtitle?: boolean;
  showBannerInList?: boolean;
};

export type AddStoryComponentRequest = ComponentBaseRequest & object;

export interface AddTagRequest {
  title?: string;
  slug?: string;
  description?: string | null;
  isPromotion?: boolean;
}

export type AddTestimonialComponentRequest = ComponentBaseRequest & object;

export type AddTextStoryComponentRequest = ComponentBaseRequest & object;

export type BannerComponentViewModel = ComponentBaseViewModel & {
  businessType?: BusinessType;
  items?: BannerItemViewModel[] | null;
};

export interface BannerComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: BannerComponentViewModel;
}

export type BannerItemRequest = ImageComponentItemRequest & object;

export interface BannerItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  businessType?: BusinessType;
  displayStatus?: ComponentDisplayStatus;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export interface BannerItemViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: BannerItemViewModel[] | null;
}

export interface BannerItemViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: BannerItemViewModelPaginationViewModel;
}

export type BannerTileComponentViewModel = ComponentBaseViewModel & {
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
  displayType?: ComponentDisplayType;
  items?: BannerTileItemViewModel[] | null;
};

export interface BannerTileComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: BannerTileComponentViewModel;
}

export interface BannerTileItemComponentRequest {
  items?: BannerTileItemRequest[] | null;
}

export type BannerTileItemRequest = ComponentItemRequest & {
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
  /** @format uri */
  imageUrl?: string | null;
};

export interface BannerTileItemViewModel {
  id?: string | null;
  title?: string | null;
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
  /** @format uri */
  link?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  businessType?: BusinessType;
  displayStatus?: ComponentDisplayStatus;
  /** @format uri */
  imageUrl?: string | null;
}

export interface BannerTileItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: BannerTileItemViewModel[] | null;
}

export interface BinobanSynchronizerViewModel {
  /** @format int32 */
  statusCode?: number;
  status?: string | null;
}

export interface BinobanSynchronizerViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: BinobanSynchronizerViewModel;
}

export interface BrandListViewModel {
  id?: string;
  slug?: string;
  nameFa?: string;
  nameEn?: string;
}

export interface BrandListViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: BrandListViewModel[] | null;
}

export interface BrandListViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: BrandListViewModelPaginationViewModel;
}

export interface BrandViewModel {
  /** @format int32 */
  id?: number;
  nameFa?: string;
  nameEn?: string;
  slug?: string;
}

export type ButtonComponentRequest = ComponentBaseRequest & {
  /** @format uri */
  link?: string | null;
  designType?: ButtonDesignType;
};

export type ButtonComponentViewModel = ComponentBaseViewModel & {
  /** @format uri */
  link?: string | null;
  buttonDesignType?: ButtonDesignType;
};

export interface ButtonComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: ButtonComponentViewModel;
}

export interface CarouselBrandComponentItemRequest {
  items?: CarouselItemRequest[] | null;
}

export type CarouselBrandComponentViewModel = ComponentBaseViewModel & {
  items?: CarouselIconItemViewModel[] | null;
};

export interface CarouselBrandComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselBrandComponentViewModel;
}

export interface CarouselBrandItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  businessType?: BusinessType;
}

export interface CarouselBrandItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselBrandItemViewModel[] | null;
}

export type CarouselComponentViewModel = ComponentBaseViewModel & {
  items?: CarouselItemViewModel[] | null;
};

export interface CarouselComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselComponentViewModel;
}

export interface CarouselIconComponentItemRequest {
  items?: CarouselIconItemRequest[] | null;
}

export type CarouselIconComponentViewModel = ComponentBaseViewModel & {
  items?: CarouselIconItemViewModel[] | null;
};

export interface CarouselIconComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselIconComponentViewModel;
}

export type CarouselIconItemRequest = ComponentItemRequest & {
  /** @format uri */
  imageUrl?: string | null;
};

export interface CarouselIconItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  businessType?: BusinessType;
}

export interface CarouselIconItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselIconItemViewModel[] | null;
}

export interface CarouselItemAddRequest {
  id?: ComponentItemId;
  title?: string;
  /** @format uri */
  mobileImageUrl?: string;
  /** @format uri */
  desktopImageUrl?: string;
  /** @format uri */
  link?: string;
  businessType?: BusinessType;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export type CarouselItemRequest = ImageComponentItemRequest & object;

export interface CarouselItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  businessType?: BusinessType;
  displayStatus?: ComponentDisplayStatus;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export interface CarouselItemViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: CarouselItemViewModel[] | null;
}

export interface CarouselItemViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselItemViewModelPaginationViewModel;
}

export interface CarouselItemViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselItemViewModel;
}

export type CarouselTextComponentViewModel = ComponentBaseViewModel & {
  items?: CarouselTextItemViewModel[] | null;
};

export interface CarouselTextComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselTextComponentViewModel;
}

export interface CarouselTextItemRequest {
  id?: string | null;
  title?: string;
  /** @format uri */
  link?: string;
}

export interface CarouselTextItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
}

export interface CarouselTextItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: CarouselTextItemViewModel[] | null;
}

export interface CategoryId {
  /** @format int32 */
  value?: number;
}

export interface CategoryTreeItemViewModel {
  id?: string | null;
  nameFa?: string | null;
  nameEn?: string | null;
  slug?: string | null;
  imageUrl?: string | null;
  children?: CategoryTreeItemViewModel[] | null;
}

export interface CategoryTreeItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: CategoryTreeItemViewModel[] | null;
}

export interface CategoryViewModel {
  id?: string | null;
  nameFa?: string | null;
}

export interface CommentBrandViewModel {
  /** @format int32 */
  id?: number;
  nameFa?: string | null;
  nameEn?: string | null;
  slug?: string | null;
}

export interface CommentCategoryViewModel {
  id?: string | null;
  /** @format int32 */
  level?: number;
  slug?: string | null;
  nameFa?: string | null;
}

export interface CommentProductViewModel {
  /** @format int32 */
  id?: number;
  slug?: string | null;
  nameFa?: string | null;
  nameEn?: string | null;
}

export interface ComponentBaseRequest {
  title?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  isPublished?: boolean;
}

export interface ComponentBaseViewModel {
  id?: string | null;
  title?: string | null;
  type?: ComponentType;
  deviceTypes?: ClientDeviceType;
  /** @format int32 */
  displayOrder?: number;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  isPublished?: boolean;
  displayStatus?: ComponentDisplayStatus;
}

export interface ComponentBaseViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?:
    | ComponentBaseViewModel
    | ImageComponentViewModel
    | VideoComponentViewModel
    | TextStoryViewModel
    | TextComponentViewModel
    | TestimonialViewModel
    | StoryComponentViewModel
    | ProductListComponentViewModel
    | MobileCarouselDesktopTileComponentViewModel
    | ComponentListItemViewModel
    | CountDownComponentViewModel
    | CarouselComponentViewModel
    | CarouselTextComponentViewModel
    | CarouselIconComponentViewModel
    | CarouselBrandComponentViewModel
    | ButtonComponentViewModel
    | BannerTileComponentViewModel
    | BannerComponentViewModel
    | null;
}

export interface ComponentDisplayOrderRequest {
  id?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export interface ComponentItemDisplayOrderRequest {
  id?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export interface ComponentItemId {
  /** @format uuid */
  value?: string;
}

export type ComponentItemRequest = ItemBaseRequest & {
  title?: string | null;
  /** @format uri */
  link?: string | null;
};

export type ComponentListItemViewModel = ComponentBaseViewModel & {
  backgroundColor?: string | null;
  designType?: ComponentDesignType;
  displayType?: ComponentDisplayType;
  /** @format int32 */
  itemsCount?: number;
  /** @format int32 */
  activeItemsCount?: number;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format uri */
  videoUrl?: string;
  /** @format uri */
  thumbnailImageUrl?: string;
  buttonDesignType?: ButtonDesignType;
  text?: string | null;
  sortKey?: string;
  showBannerInList?: boolean;
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
};

export interface ComponentListItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: ComponentListItemViewModel[] | null;
}

export type CountDownComponentRequest = ImageComponentBaseRequest & {
  /** @format date-time */
  endTime?: string;
  backgroundColor?: string | null;
};

export type CountDownComponentViewModel = ImageComponentViewModel & {
  /** @format date-time */
  endTime?: string;
  backgroundColor?: string | null;
};

export interface CountDownComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: CountDownComponentViewModel;
}

export interface CreateHeaderElementRequest {
  title?: string | null;
  businessTypes?: BusinessType;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string | null;
}

export interface CreatePageRequest {
  title?: string;
  slug?: string;
  isPublished?: boolean;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
}

export type CreatePlpBannerRequest = PlpBannerRequestBase & object;

export interface CreatePopUpElementRequest {
  title?: string;
  businessTypes?: BusinessType;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string;
  description?: string;
  buttonTitle?: string;
  voucherCode?: string | null;
  categorySelectionType?: SelectionType;
  categories?: string[] | null;
  tagSelectionType?: SelectionType;
  tags?: number[] | null;
  brandSelectionType?: SelectionType;
  brands?: string[] | null;
  homepageVisibility?: boolean;
}

export interface FailureEnvelop {
  isSuccess?: boolean;
  errors?: IEnvelopError[];
}

export interface GetCommentsViewModel {
  /** @format uuid */
  id?: string;
  comment?: string;
  /** @format int32 */
  rate?: number | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  approvedAt?: string | null;
  status?: PublicationStatus;
  isBuyer?: boolean;
  /** @format uuid */
  creatorId?: string | null;
  creatorName?: string | null;
  /** @format uuid */
  approverId?: string | null;
  approverName?: string | null;
  brand?: CommentBrandViewModel;
  category?: CommentCategoryViewModel;
  rejectReason?: RejectCommentReasonViewModel;
  product?: CommentProductViewModel;
  imageUrls?: string[];
}

export interface GetCommentsViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: GetCommentsViewModel[] | null;
}

export interface GetCommentsViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetCommentsViewModelPaginationViewModel;
}

export interface GetHeaderElementViewModel {
  /** @format int64 */
  id?: number;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  mobileImageUrl?: string | null;
}

export interface GetHeaderElementViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetHeaderElementViewModel;
}

export interface GetPageComponentItemViewModel {
  id?: string;
  title?: string;
  subTitle?: string;
  link?: string;
  mobileImageUrl?: string;
  desktopImageUrl?: string;
  brandMobileImageUrl?: string;
  brandDesktopImageUrl?: string;
  text?: string;
  /** @format int32 */
  displayOrder?: number;
  product?: ProductViewModel;
  items?: GetPageComponentItemViewModel[];
  /** @format int32 */
  index?: number;
  showNumber?: boolean;
}

export interface GetPageComponentViewModel {
  type?: ComponentType;
  deviceTypes?: ClientDeviceType;
  id?: string;
  title?: string;
  subTitle?: string;
  showTitleAndSubtitle?: boolean;
  showBannerInList?: boolean;
  backgroundColor?: string | null;
  seeMoreLink?: string | null;
  designType?: ComponentDesignType;
  displayType?: ComponentDisplayType;
  mobileImageUrl?: string;
  desktopImageUrl?: string;
  link?: string;
  /** @format date-time */
  endTime?: string;
  /** @format uri */
  videoUrl?: string;
  /** @format uri */
  thumbnailImageUrl?: string;
  text?: string;
  buttonDesignType?: ButtonDesignType;
  sortKey?: string;
  /** @format int32 */
  deactivationCountdownSecs?: number | null;
  items?: GetPageComponentItemViewModel[];
}

export interface GetPageViewModel {
  title?: string;
  seo?: SeoMetaTagsViewModel;
  components?: GetPageComponentViewModel[];
}

export interface GetPageViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetPageViewModel;
}

export interface GetPlpBannerViewModel {
  /** @format int64 */
  id?: number;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  link?: string | null;
  name?: string | null;
}

export interface GetPlpBannerViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetPlpBannerViewModel;
}

export interface GetPopUpElementViewModel {
  /** @format int64 */
  id?: number;
  title?: string;
  hasDefaultPic?: boolean;
  /** @format uri */
  mobileImageUrl?: string;
  /** @format uri */
  desktopImageUrl?: string;
  description?: string;
  buttonTitle?: string;
  /** @format uri */
  link?: string;
  voucherCode?: string | null;
  plpTrigger?: VisibilityConditionViewmodel;
  homePageTrigger?: VisibilityConditionViewmodel;
  postPone?: VisibilityConditionViewmodel;
}

export interface GetPopUpElementViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetPopUpElementViewModel;
}

export interface GetProductCommentsViewModel {
  /** @format uuid */
  id?: string;
  userName?: string | null;
  description?: string | null;
  /** @format int32 */
  likeCount?: number;
  isBuyer?: boolean;
  /** @format date-time */
  createdAt?: string;
  imageUrls?: string[] | null;
}

export interface GetProductCommentsViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: GetProductCommentsViewModel[] | null;
}

export interface GetProductCommentsViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetProductCommentsViewModelPaginationViewModel;
}

export interface GetShortCategoryListViewModel {
  categories?: ShortCategoryListItemViewModel[] | null;
}

export interface GetShortCategoryListViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetShortCategoryListViewModel;
}

export interface GetShortLabelListViewModel {
  labels?: string[];
}

export interface GetShortLabelListViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetShortLabelListViewModel;
}

export interface GetShortTokenViewModel {
  token?: string | null;
  userId?: string | null;
  slug?: string | null;
  /** @format int32 */
  likeCount?: number;
  isLiked?: boolean;
  /** @format int32 */
  commentsCount?: number;
  displayName?: string | null;
  session?: string | null;
}

export interface GetShortTokenViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetShortTokenViewModel;
}

export interface GetShortVideoListViewModel {
  cover?: string;
  video?: string | null;
  title?: string;
  caption?: string;
  slug?: string | null;
  streamUrl?: string | null;
}

export interface GetShortVideoListViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: GetShortVideoListViewModel[] | null;
}

export interface GetShortVideoListViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetShortVideoListViewModelPaginationViewModel;
}

export interface GetShortVideoViewModel {
  cover?: string;
  video?: string | null;
  title?: string;
  caption?: string;
  slug?: string | null;
  streamUrl?: string;
  /** @format int32 */
  likeCount?: number;
  isLiked?: boolean;
  products?: ShortVideoProductViewModel[] | null;
}

export interface GetShortVideoViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetShortVideoViewModel;
}

export interface GetStoryListViewModel {
  /** @format uuid */
  id?: string;
  commentImage?: string;
  commentText?: string;
  /** @format date-time */
  commentTime?: string;
  username?: string;
  isBuyer?: boolean;
  /** @format int32 */
  rate?: number | null;
  product?: ProductViewModel;
}

export interface GetStoryListViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: GetStoryListViewModel;
}

export type HeaderElementViewModel = PageElementViewModel & object;

export interface HeaderElementViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: HeaderElementViewModel[] | null;
}

export interface HeaderElementViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: HeaderElementViewModelPaginationViewModel;
}

export interface HeaderElementViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: HeaderElementViewModel;
}

export interface IEnvelopError {
  code?: string;
  message?: string;
  property?: string | null;
  attemptedValue?: any;
  details?: string | null;
}

export type ImageComponentBaseRequest = ComponentBaseRequest & {
  /** @format uri */
  mobileImageUrl?: string;
  /** @format uri */
  desktopImageUrl?: string;
  /** @format uri */
  link?: string | null;
};

export type ImageComponentItemRequest = ComponentItemRequest & {
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
};

export type ImageComponentViewModel = ComponentBaseViewModel & {
  /** @format uri */
  link?: string | null;
  /** @format uri */
  mobileImageUrl?: string;
  /** @format uri */
  desktopImageUrl?: string;
};

export interface ImageInfo {
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  sizeBytes?: number;
  /** @format int32 */
  sizeKilobytes?: number;
  format?: ImageFormat;
  /** @format double */
  aspectRatio?: number;
}

export interface ImageInfoSuccessEnvelop {
  isSuccess?: boolean;
  data?: ImageInfo;
}

export interface ItemBaseRequest {
  id?: string | null;
  businessType?: BusinessType;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  /** @format int32 */
  displayOrder?: number;
}

export type ItemGroupBase = ItemBaseRequest & object;

export type MobileCarouselDesktopTileComponentViewModel =
  ComponentBaseViewModel & {
    items?: MobileCarouselDesktopTileItemGroupViewModel[] | null;
  };

export interface MobileCarouselDesktopTileComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: MobileCarouselDesktopTileComponentViewModel;
}

export type MobileCarouselDesktopTileItemGroupRequest = ItemGroupBase & {
  items?: MobileCarouselDesktopTileItemRequest[] | null;
};

export type MobileCarouselDesktopTileItemGroupViewModel = ItemGroupBase & {
  displayStatus?: ComponentDisplayStatus;
  items?: MobileCarouselDesktopTileItemViewModel[] | null;
};

export interface MobileCarouselDesktopTileItemGroupViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: MobileCarouselDesktopTileItemGroupViewModel[] | null;
}

export interface MobileCarouselDesktopTileItemGroupViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: MobileCarouselDesktopTileItemGroupViewModelPaginationViewModel;
}

export interface MobileCarouselDesktopTileItemGroupViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: MobileCarouselDesktopTileItemGroupViewModel;
}

export type MobileCarouselDesktopTileItemRequest = ImageComponentItemRequest &
  object;

export interface MobileCarouselDesktopTileItemViewModel {
  id?: string | null;
  title?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  businessType?: BusinessType;
  displayStatus?: ComponentDisplayStatus;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
}

export interface PageElementViewModel {
  /** @format int64 */
  id?: number;
  title?: string;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  businessTypes?: BusinessType;
  displayStatus?: PageElementDisplayStatus;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  createdAt?: string;
  type?: PageElementType;
}

export interface PageViewModel {
  id?: string;
  title?: string;
  slug?: string;
  isPublished?: boolean;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  /** @format int32 */
  componentsCount?: number;
  seo?: SeoMetaTagsViewModel;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface PageViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: PageViewModel[] | null;
}

export interface PageViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PageViewModelPaginationViewModel;
}

export interface PageViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PageViewModel;
}

export interface PlpBannerListViewModel {
  id?: string | null;
  name?: string | null;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string | null;
  isPublished?: boolean;
  type?: PlpBannerType;
  categories?: CategoryViewModel[] | null;
  tags?: TagAdminViewModel[] | null;
  /** @format date-time */
  startsAt?: string | null;
  /** @format date-time */
  endsAt?: string | null;
}

export interface PlpBannerListViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: PlpBannerListViewModel[] | null;
}

export interface PlpBannerListViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PlpBannerListViewModelPaginationViewModel;
}

export interface PlpBannerListViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PlpBannerListViewModel;
}

export interface PlpBannerRequestBase {
  /** @minLength 1 */
  name: string;
  /** @format uri */
  mobileImageUrl: string;
  /** @format uri */
  desktopImageUrl: string;
  /** @format uri */
  link: string;
  isPublished: boolean;
  type?: PlpBannerType;
  categoryIds?: string[] | null;
  tagIds?: string[] | null;
  /** @format date-time */
  startsAt?: string | null;
  /** @format date-time */
  endsAt?: string | null;
}

export interface PopUpCategoryViwModel {
  id?: string;
  nameFa?: string;
  nameEn?: string;
  slug?: string;
  imageUrl?: string;
}

export interface PopUpElementListViewModel {
  /** @format int64 */
  id?: number;
  title?: string;
  voucherCode?: string | null;
  displayStatus?: PageElementDisplayStatus;
  businessTypes?: BusinessType;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  categorySelectionType?: SelectionType;
  categories?: PopUpCategoryViwModel[] | null;
  tagSelectionType?: SelectionType;
  tags?: TagAdminViewModel[] | null;
  brandSelectionType?: SelectionType;
  brands?: BrandViewModel[] | null;
  homepageVisibility?: boolean;
}

export interface PopUpElementListViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: PopUpElementListViewModel[] | null;
}

export interface PopUpElementListViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PopUpElementListViewModelPaginationViewModel;
}

export type PopUpElementViewModel = PageElementViewModel & {
  description?: string;
  buttonTitle?: string;
  voucherCode?: string;
  categorySelectionType?: SelectionType;
  categories?: string[] | null;
  tagSelectionType?: SelectionType;
  tags?: string[] | null;
  brandSelectionType?: SelectionType;
  brands?: string[] | null;
  homepageVisibility?: boolean;
};

export interface PopUpElementViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: PopUpElementViewModel;
}

export type ProductListComponentViewModel = ComponentBaseViewModel & {
  backgroundColor?: string | null;
  designType?: ComponentDesignType;
  subTitle?: string | null;
  /** @format uri */
  mobileImageUri?: string | null;
  /** @format uri */
  desktopImageUri?: string | null;
  showTitleAndSubtitle?: boolean;
  showBannerInList?: boolean;
  items?: ProductListItemGroupViewModel[];
};

export interface ProductListComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: ProductListComponentViewModel;
}

export type ProductListItemGroupRequest = ItemGroupBase & {
  mobileImageUrl?: string | null;
  desktopImageUrl?: string | null;
  title?: string;
  link?: string | null;
  showNumber?: boolean;
  items?: ProductListItemRequest[];
};

export type ProductListItemGroupViewModel = ItemGroupBase & {
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  title?: string;
  /** @format uri */
  link?: string | null;
  showNumber?: boolean;
  displayStatus?: ComponentDisplayStatus;
  items?: ProductListItemViewModel[];
};

export interface ProductListItemGroupViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: ProductListItemGroupViewModel[] | null;
}

export type ProductListItemRequest = ItemBaseRequest & {
  /** @minLength 1 */
  productId: string;
};

export interface ProductListItemViewModel {
  id?: string;
  businessType?: BusinessType;
  product?: ProductViewModel;
}

export interface ProductViewModel {
  id?: string;
  slug?: string;
  nameFa?: string;
  nameEn?: string | null;
  mainImageUrl?: string;
  isPublished?: boolean;
  isDiscontinued?: boolean;
  /** @format int64 */
  basePrice?: number;
  /** @format int64 */
  salesPrice?: number | null;
  /** @format int32 */
  discountPercent?: number | null;
  isSalable?: boolean;
  brand?: BrandViewModel;
}

export interface RejectCommentReasonViewModel {
  /** @format int32 */
  id?: number;
  type?: RejectCommentReasonType;
  title?: string | null;
}

export interface RejectCommentReasonViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: RejectCommentReasonViewModel[] | null;
}

export interface RejectCommentReasonViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: RejectCommentReasonViewModelPaginationViewModel;
}

export interface SeoMetaTagsViewModel {
  title?: string;
  description?: string;
}

export interface SeoViewModel {
  title?: string | null;
  description?: string | null;
  footerDescription?: string | null;
}

export interface SetComponentDisplayOrderRequest {
  components?: ComponentDisplayOrderRequest[] | null;
}

export interface SetComponentItemDisplayOrderRequest {
  items?: ComponentItemDisplayOrderRequest[] | null;
}

export interface ShortCategoryListItemViewModel {
  id?: CategoryId;
  title?: string | null;
}

export interface ShortVideoProductViewModel {
  image?: string | null;
  title?: string | null;
  url?: string | null;
  breadcrumb?: string | null;
  brand?: string | null;
  slug?: string | null;
}

export type StoryComponentViewModel = ComponentBaseViewModel & object;

export interface StoryComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: StoryComponentViewModel;
}

export interface SuccessEnvelop {
  isSuccess?: boolean;
  data?: any;
}

export interface TagAdminViewModel {
  /** @format int32 */
  id?: number;
  title?: string;
  slug?: string;
  description?: string | null;
  isPromotion?: boolean;
  seo?: SeoViewModel;
}

export interface TagAdminViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TagAdminViewModel;
}

export interface TagListViewModel {
  /** @format int32 */
  id?: number;
  title?: string | null;
  slug?: string | null;
  isPromotion?: boolean;
  /** @format int32 */
  productsCount?: number;
}

export interface TagListViewModelPaginationViewModel {
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  items?: TagListViewModel[] | null;
}

export interface TagListViewModelPaginationViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TagListViewModelPaginationViewModel;
}

export interface TagViewModel {
  /** @format int32 */
  id?: number;
  title?: string;
  seoH1?: string;
  slug?: string;
  description?: string | null;
  isPromotion?: boolean;
  seo?: SeoViewModel;
}

export interface TagViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TagViewModel;
}

export interface TestimonialComponentItemRequest {
  items?: TestimonialItemRequest[] | null;
}

export type TestimonialItemRequest = ComponentItemRequest & {
  text?: string | null;
  /** @format uri */
  imageUrl?: string | null;
  /** @format uri */
  brandImageUrl?: string | null;
};

export interface TestimonialItemViewModel {
  id?: string | null;
  title?: string | null;
  text?: string | null;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  imageUrl?: string | null;
  /** @format uri */
  brandImageUrl?: string | null;
  /** @format int32 */
  displayOrder?: number;
  businessType?: BusinessType;
}

export interface TestimonialItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: TestimonialItemViewModel[] | null;
}

export type TestimonialViewModel = ComponentBaseViewModel & object;

export interface TestimonialViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TestimonialViewModel;
}

export type TextComponentRequest = ComponentBaseRequest & {
  text?: string | null;
};

export type TextComponentViewModel = ComponentBaseViewModel & {
  text?: string | null;
};

export interface TextComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TextComponentViewModel;
}

export interface TextStoryComponentItemRequest {
  items?: TextStoryItemRequest[] | null;
}

export type TextStoryItemRequest = ComponentItemRequest & {
  /** @format int32 */
  productId?: number | null;
  text?: string | null;
  /** @format uri */
  imageUrl?: string | null;
};

export interface TextStoryItemViewModel {
  id?: string | null;
  title?: string | null;
  text?: string | null;
  /** @format int32 */
  productId?: number;
  /** @format uri */
  link?: string | null;
  /** @format uri */
  imageUrl?: string | null;
  /** @format int32 */
  displayOrder?: number;
  businessType?: BusinessType;
}

export interface TextStoryItemViewModelListSuccessEnvelop {
  isSuccess?: boolean;
  data?: TextStoryItemViewModel[] | null;
}

export type TextStoryViewModel = ComponentBaseViewModel & object;

export interface TextStoryViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: TextStoryViewModel;
}

export type UpdateBannerTileComponentRequest = ComponentBaseRequest & {
  subTitle?: string | null;
  showTitleAndSubtitle?: boolean;
  displayType?: ComponentDisplayType;
};

export type UpdateCarouselBigComponentRequest = ComponentBaseRequest & {
  items?: CarouselItemRequest[] | null;
};

export type UpdateCarouselMediumComponentRequest = ComponentBaseRequest & {
  items?: CarouselItemRequest[] | null;
};

export interface UpdateCarouselTextComponentRequest {
  items?: CarouselTextItemRequest[] | null;
}

export interface UpdateCommentStatusRequest {
  /** @format int32 */
  status: number;
  /** @format int32 */
  rejectCommentReasonId?: number | null;
}

export interface UpdateHeaderElementRequest {
  title?: string | null;
  businessTypes?: BusinessType;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string | null;
}

export interface UpdatePageRequest {
  title?: string;
  slug?: string;
  isPublished?: boolean;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
}

export type UpdatePlpBannerRequest = PlpBannerRequestBase & object;

export interface UpdatePopUpElementRequest {
  title?: string;
  businessTypes?: BusinessType;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format uri */
  mobileImageUrl?: string | null;
  /** @format uri */
  desktopImageUrl?: string | null;
  /** @format uri */
  link?: string;
  description?: string;
  buttonTitle?: string;
  voucherCode?: string | null;
  categorySelectionType?: SelectionType;
  categories?: string[] | null;
  tagSelectionType?: SelectionType;
  tags?: number[] | null;
  brandSelectionType?: SelectionType;
  brands?: string[] | null;
  homepageVisibility?: boolean;
}

export type UpdateProductListComponentRequest = ComponentBaseRequest & {
  designType?: ComponentDesignType;
  backgroundColor?: string | null;
  subTitle?: string | null;
  /** @format uri */
  mobileImageUri?: string | null;
  /** @format uri */
  desktopImageUri?: string | null;
  showTitleAndSubtitle?: boolean;
  showBannerInList?: boolean;
};

export interface UpdateSeoRequest {
  title?: string | null;
  description?: string | null;
  footerDescription?: string | null;
}

export type UpdateStoryComponentRequest = ComponentBaseRequest & object;

export interface UpdateTagRequest {
  title?: string;
  slug?: string;
  description?: string | null;
  isPromotion?: boolean;
}

export interface UploadImageViewModel {
  url?: string | null;
}

export interface UploadImageViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: UploadImageViewModel;
}

export type VideoComponentRequest = ComponentBaseRequest & {
  /** @format uri */
  videoUrl?: string | null;
  /** @format uri */
  thumbnailImageUrl?: string | null;
};

export type VideoComponentViewModel = ComponentBaseViewModel & {
  /** @format uri */
  videoUrl?: string | null;
  /** @format uri */
  thumbnailImageUrl?: string | null;
};

export interface VideoComponentViewModelSuccessEnvelop {
  isSuccess?: boolean;
  data?: VideoComponentViewModel;
}

export interface VisibilityConditionViewmodel {
  type?: ConditionType;
  /** @format int32 */
  conditionValue?: number;
}

export type XmlSitemapResult = ActionResult & object;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Chameleon
 * @version v1
 *
 * Chameleon back-end (Web API)
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  internal = {
    /**
     * No description
     *
     * @tags Binoban
     * @name ApiCmlV1BinobanProductCreate
     * @request POST:/__internal/api/cml/v1/binoban/product
     */
    apiCmlV1BinobanProductCreate: (
      query?: {
        /** @format int32 */
        product_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BinobanSynchronizerViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/__internal/api/cml/v1/binoban/product`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Binoban
     * @name ApiCmlV1BinobanCategoryCreate
     * @request POST:/__internal/api/cml/v1/binoban/category
     */
    apiCmlV1BinobanCategoryCreate: (
      query?: {
        /** @format int32 */
        category_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BinobanSynchronizerViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/__internal/api/cml/v1/binoban/category`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name ApiCmlV1CategoryChangeParentCreate
     * @request POST:/__internal/api/cml/v1/category/change-parent
     */
    apiCmlV1CategoryChangeParentCreate: (
      query?: {
        /** @format int32 */
        category_id?: number;
        /** @format int32 */
        parent_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActionResultSuccessEnvelop, FailureEnvelop>({
        path: `/__internal/api/cml/v1/category/change-parent`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ApiCmlV1ProductCategoriesSampleList
     * @request GET:/__internal/api/cml/v1/product/categories/sample
     */
    apiCmlV1ProductCategoriesSampleList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/__internal/api/cml/v1/product/categories/sample`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ApiCmlV1ProductCategoriesImportCreate
     * @request POST:/__internal/api/cml/v1/product/categories/import
     */
    apiCmlV1ProductCategoriesImportCreate: (
      data: {
        /** @format binary */
        file?: File;
        delete_other_categories?: boolean;
        /** @default true */
        include_first_row?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CategoryTreeItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/__internal/api/cml/v1/product/categories/import`,
          method: "POST",
          body: data,
          type: ContentType.FormData,
          format: "json",
          ...params,
        },
      ),
  };
  api = {
    /**
     * No description
     *
     * @tags Brand
     * @name CmlAdminV1BrandsList
     * @request GET:/api/cml/admin/v1/brands
     */
    cmlAdminV1BrandsList: (
      query?: {
        name?: string;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 10000
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BrandListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/brands`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Category
     * @name CmlAdminV1CategoriesList
     * @request GET:/api/cml/admin/v1/categories
     */
    cmlAdminV1CategoriesList: (
      query?: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CategoryTreeItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/categories`,
          method: "GET",
          query: query,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Comment
     * @name CmlV1ProductsIdCommentsList
     * @request GET:/api/cml/v1/products/id/{id}/comments
     */
    cmlV1ProductsIdCommentsList: (
      id: string,
      query?: {
        has_image?: boolean;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 10000
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GetProductCommentsViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/v1/products/id/${id}/comments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name CmlV1ProductsIdCommentsCreate
     * @request POST:/api/cml/v1/products/id/{id}/comments
     */
    cmlV1ProductsIdCommentsCreate: (
      id: string,
      data: {
        Comment: string;
        /** @format int32 */
        Rate: number;
        Images?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/products/id/${id}/comments`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name CmlAdminV1CommentsIdUpdate
     * @request PUT:/api/cml/admin/v1/comments/id/{id}
     */
    cmlAdminV1CommentsIdUpdate: (
      id: string,
      data: UpdateCommentStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/comments/id/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name CmlAdminV1CommentsRejectCommentReasonsList
     * @request GET:/api/cml/admin/v1/comments/reject-comment-reasons
     */
    cmlAdminV1CommentsRejectCommentReasonsList: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 10000
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RejectCommentReasonViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/comments/reject-comment-reasons`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comment
     * @name CmlAdminV1CommentsList
     * @request GET:/api/cml/admin/v1/comments
     */
    cmlAdminV1CommentsList: (
      query?: {
        product_ids?: string[];
        brand_ids?: string[];
        category_ids?: string[];
        has_image?: boolean;
        is_buyer?: boolean;
        statuses?: PublicationStatus[];
        /** @format date-time */
        created_from?: string;
        /** @format date-time */
        created_to?: string;
        comment?: string;
        creator_name?: string;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 10000
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GetCommentsViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/comments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name CmlAdminV1ImagesList
     * @request GET:/api/cml/admin/v1/images
     */
    cmlAdminV1ImagesList: (
      query: {
        /** @format uri */
        imageUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageInfoSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/images`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name CmlAdminV1ImagesCreate
     * @request POST:/api/cml/admin/v1/images
     */
    cmlAdminV1ImagesCreate: (
      data: {
        /** @format binary */
        Image: File;
        DeviceType: DeviceType;
        ImageType: ImageType;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadImageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/images`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlV1PagesList
     * @request GET:/api/cml/v1/pages
     */
    cmlV1PagesList: (
      query?: {
        /** @default "/" */
        slug?: string;
        /** @default false */
        preview?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/pages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}
     */
    cmlAdminV1PagesIdUpdate: (
      id: string,
      data: UpdatePageRequest,
      params: RequestParams = {},
    ) =>
      this.request<PageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}
     */
    cmlAdminV1PagesIdDetail: (id: string, params: RequestParams = {}) =>
      this.request<PageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdDelete
     * @request DELETE:/api/cml/admin/v1/pages/id/{id}
     */
    cmlAdminV1PagesIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesList
     * @request GET:/api/cml/admin/v1/pages
     */
    cmlAdminV1PagesList: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
        title?: string;
        slug?: string;
        is_published?: boolean;
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesCreate
     * @request POST:/api/cml/admin/v1/pages
     */
    cmlAdminV1PagesCreate: (
      data: CreatePageRequest,
      params: RequestParams = {},
    ) =>
      this.request<PageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1HomePageList
     * @request GET:/api/cml/admin/v1/home-page
     */
    cmlAdminV1HomePageList: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/home-page`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesLandingsIdDetail
     * @request GET:/api/cml/admin/v1/pages/landings/id/{id}
     */
    cmlAdminV1PagesLandingsIdDetail: (id: string, params: RequestParams = {}) =>
      this.request<PageViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/landings/id/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsVideosVideoIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/videos/video-id/{video_id}
     */
    cmlAdminV1PagesIdComponentsVideosVideoIdUpdate: (
      id: string,
      videoId: string,
      data: VideoComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<VideoComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/videos/video-id/${videoId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsVideosVideoIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/videos/video-id/{video_id}
     */
    cmlAdminV1PagesIdComponentsVideosVideoIdDetail: (
      id: string,
      videoId: string,
      params: RequestParams = {},
    ) =>
      this.request<VideoComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/videos/video-id/${videoId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsVideosCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/videos
     */
    cmlAdminV1PagesIdComponentsVideosCreate: (
      id: string,
      data: VideoComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<VideoComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/videos`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsComponentIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/component-id/{component_id}
     */
    cmlAdminV1PagesIdComponentsComponentIdUpdate: (
      id: string,
      componentId: string,
      data:
        | ComponentBaseRequest
        | ImageComponentBaseRequest
        | VideoComponentRequest
        | AddTextStoryComponentRequest
        | TextComponentRequest
        | AddTestimonialComponentRequest
        | UpdateStoryComponentRequest
        | AddStoryComponentRequest
        | UpdateProductListComponentRequest
        | AddProductListComponentRequest
        | AddMobileCarouselDesktopTileComponentRequest
        | CountDownComponentRequest
        | AddCarouselVideoRequest
        | AddCarouselTextComponentRequest
        | UpdateCarouselMediumComponentRequest
        | AddCarouselMediumComponentRequest
        | AddCarouselIconComponentRequest
        | AddCarouselBrandComponentRequest
        | UpdateCarouselBigComponentRequest
        | AddCarouselBigComponentRequest
        | ButtonComponentRequest
        | UpdateBannerTileComponentRequest
        | AddBannerTileComponentRequest
        | AddBannerComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ComponentBaseViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/component-id/${componentId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsComponentIdDelete
     * @request DELETE:/api/cml/admin/v1/pages/id/{id}/components/component-id/{component_id}
     */
    cmlAdminV1PagesIdComponentsComponentIdDelete: (
      id: string,
      componentId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/component-id/${componentId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextStoriesTextStoryIdItemUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/text-stories/text-story-id/{text_story_id}/item
     */
    cmlAdminV1PagesIdComponentsTextStoriesTextStoryIdItemUpdate: (
      id: string,
      textStoryId: string,
      data: TextStoryComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<TextStoryItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-stories/text-story-id/${textStoryId}/item`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextStoriesTextStoryIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/text-stories/text-story-id/{text_story_id}/item
     */
    cmlAdminV1PagesIdComponentsTextStoriesTextStoryIdItemCreate: (
      id: string,
      textStoryId: string,
      data: TextStoryComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<TextStoryItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-stories/text-story-id/${textStoryId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextStoriesTextStoryIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/text-stories/text-story-id/{text_story_id}
     */
    cmlAdminV1PagesIdComponentsTextStoriesTextStoryIdDetail: (
      id: string,
      textStoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<TextStoryItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-stories/text-story-id/${textStoryId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextStoriesCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/text-stories
     */
    cmlAdminV1PagesIdComponentsTextStoriesCreate: (
      id: string,
      data: AddTextStoryComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TextStoryViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-stories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextsTextIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/texts/text-id/{text_id}
     */
    cmlAdminV1PagesIdComponentsTextsTextIdUpdate: (
      id: string,
      textId: string,
      data: TextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TextComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/texts/text-id/${textId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextsTextIdTextIdList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/texts/text-id/{text-id}
     */
    cmlAdminV1PagesIdComponentsTextsTextIdTextIdList: (
      id: string,
      textId: string,
      params: RequestParams = {},
    ) =>
      this.request<TextComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/texts/text-id/${textId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/text
     */
    cmlAdminV1PagesIdComponentsTextCreate: (
      id: string,
      data: TextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TextComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTestimonialsTestimonialIdItemUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/testimonials/testimonial-id/{testimonial_id}/item
     */
    cmlAdminV1PagesIdComponentsTestimonialsTestimonialIdItemUpdate: (
      id: string,
      testimonialId: string,
      data: TestimonialComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<TestimonialItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/testimonials/testimonial-id/${testimonialId}/item`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTestimonialsTestimonialIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/testimonials/testimonial-id/{testimonial_id}/item
     */
    cmlAdminV1PagesIdComponentsTestimonialsTestimonialIdItemCreate: (
      id: string,
      testimonialId: string,
      data: TestimonialComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<TestimonialItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/testimonials/testimonial-id/${testimonialId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTestimonialsTestimonialIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/testimonials/testimonial-id/{testimonial_id}
     */
    cmlAdminV1PagesIdComponentsTestimonialsTestimonialIdDetail: (
      id: string,
      testimonialId: string,
      params: RequestParams = {},
    ) =>
      this.request<TestimonialItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/testimonials/testimonial-id/${testimonialId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTestimonialsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/testimonials
     */
    cmlAdminV1PagesIdComponentsTestimonialsCreate: (
      id: string,
      data: AddTestimonialComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TestimonialViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/testimonials`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsStoriesStoryIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/stories/story-id/{story_id}
     */
    cmlAdminV1PagesIdComponentsStoriesStoryIdUpdate: (
      id: string,
      storyId: string,
      data: UpdateStoryComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<StoryComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/stories/story-id/${storyId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsStoriesStoryIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/stories/story-id/{story_id}
     */
    cmlAdminV1PagesIdComponentsStoriesStoryIdDetail: (
      id: string,
      storyId: string,
      params: RequestParams = {},
    ) =>
      this.request<StoryComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/stories/story-id/${storyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsStoriesCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/stories
     */
    cmlAdminV1PagesIdComponentsStoriesCreate: (
      id: string,
      data: AddStoryComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<StoryComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/stories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsComponentIdItemDisplayOrderUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/component-id/{component_id}/item-display-order
     */
    cmlAdminV1PagesIdComponentsComponentIdItemDisplayOrderUpdate: (
      id: string,
      componentId: string,
      data: SetComponentItemDisplayOrderRequest,
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/component-id/${componentId}/item-display-order`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsDisplayOrderUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components-display-order
     */
    cmlAdminV1PagesIdComponentsDisplayOrderUpdate: (
      id: string,
      data: SetComponentDisplayOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components-display-order`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsProductListsProductListIdItemsUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/product-lists/product-list-id/{product_list_id}/items
     */
    cmlAdminV1PagesIdComponentsProductListsProductListIdItemsUpdate: (
      id: string,
      productListId: string,
      data: ProductListItemGroupRequest[],
      params: RequestParams = {},
    ) =>
      this.request<
        ProductListItemGroupViewModelListSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/product-lists/product-list-id/${productListId}/items`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsProductListsProductListIdItemsList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/product-lists/product-list-id/{product_list_id}/items
     */
    cmlAdminV1PagesIdComponentsProductListsProductListIdItemsList: (
      id: string,
      productListId: string,
      query?: {
        /** @format date-time */
        item_from_date?: string;
        /** @format date-time */
        item_to_date?: string;
        item_display_status?: ComponentDisplayStatus;
        /** @format int32 */
        product_id?: number;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductListComponentViewModelSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/product-lists/product-list-id/${productListId}/items`,
          method: "GET",
          query: query,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsProductListsProductListIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/product-lists/product-list-id/{product_list_id}
     */
    cmlAdminV1PagesIdComponentsProductListsProductListIdUpdate: (
      id: string,
      productListId: string,
      data: UpdateProductListComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProductListComponentViewModelSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/product-lists/product-list-id/${productListId}`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsProductListsProductListIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/product-lists/product-list-id/{product_list_id}/item
     */
    cmlAdminV1PagesIdComponentsProductListsProductListIdItemCreate: (
      id: string,
      productListId: string,
      data: ProductListItemGroupRequest[],
      params: RequestParams = {},
    ) =>
      this.request<
        ProductListItemGroupViewModelListSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/product-lists/product-list-id/${productListId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsProductListsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/product-lists
     */
    cmlAdminV1PagesIdComponentsProductListsCreate: (
      id: string,
      data: AddProductListComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProductListComponentViewModelSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/product-lists`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemsUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/{mobile_carousel_desktop_tile_id}/items/{item_id}
     */
    cmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemsUpdate:
      (
        id: string,
        mobileCarouselDesktopTileId: string,
        itemId: string,
        data: MobileCarouselDesktopTileItemGroupRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          MobileCarouselDesktopTileItemGroupViewModelSuccessEnvelop,
          FailureEnvelop
        >({
          path: `/api/cml/admin/v1/pages/id/${id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/${mobileCarouselDesktopTileId}/items/${itemId}`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemsList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/{mobile_carousel_desktop_tile_id}/items
     */
    cmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemsList:
      (
        id: string,
        mobileCarouselDesktopTileId: string,
        query?: {
          item_title?: string;
          /** @format date-time */
          item_from_date?: string;
          /** @format date-time */
          item_to_date?: string;
          item_display_status?: ComponentDisplayStatus;
          /**
           * @format int32
           * @default 1
           */
          page_number?: number;
          /**
           * @format int32
           * @min 1
           * @max 300
           * @default 10
           */
          page_size?: number;
        },
        params: RequestParams = {},
      ) =>
        this.request<
          MobileCarouselDesktopTileItemGroupViewModelPaginationViewModelSuccessEnvelop,
          FailureEnvelop
        >({
          path: `/api/cml/admin/v1/pages/id/${id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/${mobileCarouselDesktopTileId}/items`,
          method: "GET",
          query: query,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/{mobile_carousel_desktop_tile_id}/item
     */
    cmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesMobileCarouselDesktopTileIdItemCreate:
      (
        id: string,
        mobileCarouselDesktopTileId: string,
        data: MobileCarouselDesktopTileItemGroupRequest,
        params: RequestParams = {},
      ) =>
        this.request<
          MobileCarouselDesktopTileItemGroupViewModelSuccessEnvelop,
          FailureEnvelop
        >({
          path: `/api/cml/admin/v1/pages/id/${id}/components/mobile-carousel-desktop-tiles/mobile-carousel-desktop-tile-id/${mobileCarouselDesktopTileId}/item`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/mobile-carousel-desktop-tiles
     */
    cmlAdminV1PagesIdComponentsMobileCarouselDesktopTilesCreate: (
      id: string,
      data: AddMobileCarouselDesktopTileComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        MobileCarouselDesktopTileComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/mobile-carousel-desktop-tiles`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components
     */
    cmlAdminV1PagesIdComponentsList: (id: string, params: RequestParams = {}) =>
      this.request<
        ComponentListItemViewModelListSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/id/{component_id}
     */
    cmlAdminV1PagesIdComponentsIdDetail: (
      id: string,
      componentId: string,
      params: RequestParams = {},
    ) =>
      this.request<ComponentBaseViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/id/${componentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsComponentIdItemsItemIdDelete
     * @request DELETE:/api/cml/admin/v1/pages/id/{id}/components/component-id/{component_id}/items/item-id/{item_id}
     */
    cmlAdminV1PagesIdComponentsComponentIdItemsItemIdDelete: (
      id: string,
      componentId: string,
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/component-id/${componentId}/items/item-id/${itemId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsCountdownsCountdownIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/countdowns/countdown-id/{countdown_id}
     */
    cmlAdminV1PagesIdComponentsCountdownsCountdownIdUpdate: (
      id: string,
      countdownId: string,
      data: CountDownComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CountDownComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/countdowns/countdown-id/${countdownId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsCountdownsCountdownIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/countdowns/countdown-id/{countdown_id}
     */
    cmlAdminV1PagesIdComponentsCountdownsCountdownIdDetail: (
      id: string,
      countdownId: string,
      params: RequestParams = {},
    ) =>
      this.request<CountDownComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/countdowns/countdown-id/${countdownId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsCountdownCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/countdown
     */
    cmlAdminV1PagesIdComponentsCountdownCreate: (
      id: string,
      data: CountDownComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CountDownComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/countdown`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsVideoCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/video-carousels
     */
    cmlAdminV1PagesIdComponentsVideoCarouselsCreate: (
      id: string,
      data: AddCarouselTextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselTextComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/video-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextCarouselsCarouselIdItemsUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/text-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsTextCarouselsCarouselIdItemsUpdate: (
      id: string,
      carouselId: string,
      data: UpdateCarouselTextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselTextItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/text-carousels/carousel-id/${carouselId}/items`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextCarouselsCarouselIdItemsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/text-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsTextCarouselsCarouselIdItemsCreate: (
      id: string,
      carouselId: string,
      data: UpdateCarouselTextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselTextItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/text-carousels/carousel-id/${carouselId}/items`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextCarouselsCarouselIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/text-carousels/carousel-id/{carousel_id}
     */
    cmlAdminV1PagesIdComponentsTextCarouselsCarouselIdDetail: (
      id: string,
      carouselId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselTextComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-carousels/carousel-id/${carouselId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsTextCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/text-carousels
     */
    cmlAdminV1PagesIdComponentsTextCarouselsCreate: (
      id: string,
      data: AddCarouselTextComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselTextComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/text-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdItemsItemIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/medium-carousels/carousel-id/{carousel_id}/items/item-id/{item_id}
     */
    cmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdItemsItemIdUpdate: (
      id: string,
      carouselId: string,
      itemId: string,
      data: CarouselItemAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselItemViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/medium-carousels/carousel-id/${carouselId}/items/item-id/${itemId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/medium-carousels/carousel-id/{carousel_id}
     */
    cmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdDetail: (
      id: string,
      carouselId: string,
      query?: {
        item_title?: string;
        /** @format date-time */
        item_from_date?: string;
        /** @format date-time */
        item_to_date?: string;
        item_display_status?: ComponentDisplayStatus;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselItemViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/medium-carousels/carousel-id/${carouselId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/medium-carousels/carousel-id/{carousel_id}/item
     */
    cmlAdminV1PagesIdComponentsMediumCarouselsCarouselIdItemCreate: (
      id: string,
      carouselId: string,
      data: CarouselItemAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselItemViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/medium-carousels/carousel-id/${carouselId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsMediumCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/medium-carousels
     */
    cmlAdminV1PagesIdComponentsMediumCarouselsCreate: (
      id: string,
      data: AddCarouselMediumComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/medium-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsIconCarouselsCarouselIdItemsUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/icon-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsIconCarouselsCarouselIdItemsUpdate: (
      id: string,
      carouselId: string,
      data: CarouselIconComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselIconItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/icon-carousels/carousel-id/${carouselId}/items`,
          method: "PUT",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsIconCarouselsCarouselIdItemsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/icon-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsIconCarouselsCarouselIdItemsCreate: (
      id: string,
      carouselId: string,
      data: CarouselIconComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselIconItemViewModelListSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/icon-carousels/carousel-id/${carouselId}/items`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsIconCarouselsCarouselIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/icon-carousels/carousel-id/{carousel_id}
     */
    cmlAdminV1PagesIdComponentsIconCarouselsCarouselIdDetail: (
      id: string,
      carouselId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselIconComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/icon-carousels/carousel-id/${carouselId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsIconCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/icon-carousels
     */
    cmlAdminV1PagesIdComponentsIconCarouselsCreate: (
      id: string,
      data: AddCarouselIconComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/icon-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdItemsUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/brand-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdItemsUpdate: (
      id: string,
      carouselId: string,
      data: CarouselBrandComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselBrandItemViewModelListSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/brand-carousels/carousel-id/${carouselId}/items`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdItemsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/brand-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdItemsCreate: (
      id: string,
      carouselId: string,
      data: CarouselBrandComponentItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselBrandItemViewModelListSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/brand-carousels/carousel-id/${carouselId}/items`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/brand-carousels/carousel-id/{carousel_id}
     */
    cmlAdminV1PagesIdComponentsBrandCarouselsCarouselIdDetail: (
      id: string,
      carouselId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselBrandComponentViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/brand-carousels/carousel-id/${carouselId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBrandCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/brand-carousels
     */
    cmlAdminV1PagesIdComponentsBrandCarouselsCreate: (
      id: string,
      data: AddCarouselBrandComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/brand-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemsItemIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/big-carousels/carousel-id/{carousel_id}/items/item-id/{item_id}
     */
    cmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemsItemIdUpdate: (
      id: string,
      carouselId: string,
      itemId: string,
      data: CarouselItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselItemViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/big-carousels/carousel-id/${carouselId}/items/item-id/${itemId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemsList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/big-carousels/carousel-id/{carousel_id}/items
     */
    cmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemsList: (
      id: string,
      carouselId: string,
      query?: {
        item_title?: string;
        /** @format date-time */
        item_from_date?: string;
        /** @format date-time */
        item_to_date?: string;
        item_display_status?: ComponentDisplayStatus;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        CarouselItemViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/big-carousels/carousel-id/${carouselId}/items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/big-carousels/carousel-id/{carousel_id}/item
     */
    cmlAdminV1PagesIdComponentsBigCarouselsCarouselIdItemCreate: (
      id: string,
      carouselId: string,
      data: CarouselItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProductListComponentViewModelSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/admin/v1/pages/id/${id}/components/big-carousels/carousel-id/${carouselId}/item`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBigCarouselsCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/big-carousels
     */
    cmlAdminV1PagesIdComponentsBigCarouselsCreate: (
      id: string,
      data: AddCarouselBigComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CarouselComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/big-carousels`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsButtonsButtonIdButtonIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/buttons/button-id/{button-id}
     */
    cmlAdminV1PagesIdComponentsButtonsButtonIdButtonIdUpdate: (
      id: string,
      buttonId: string,
      data: ButtonComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ButtonComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/buttons/button-id/${buttonId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsButtonsButtonIdButtonIdList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/buttons/button-id/{button-id}
     */
    cmlAdminV1PagesIdComponentsButtonsButtonIdButtonIdList: (
      id: string,
      buttonId: string,
      params: RequestParams = {},
    ) =>
      this.request<ButtonComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/buttons/button-id/${buttonId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsButtonCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/button
     */
    cmlAdminV1PagesIdComponentsButtonCreate: (
      id: string,
      data: ButtonComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ButtonComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/button`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles/banner-tile-id/{banner_tile_id}/item
     */
    cmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemUpdate: (
      id: string,
      bannerTileId: string,
      data: BannerTileItemComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles/banner-tile-id/${bannerTileId}/item`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles/banner-tile-id/{banner_tile_id}/item
     */
    cmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemCreate: (
      id: string,
      bannerTileId: string,
      data: BannerTileItemComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles/banner-tile-id/${bannerTileId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesBannerTileIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles/banner-tile-id/{banner_tile_id}
     */
    cmlAdminV1PagesIdComponentsBannerTilesBannerTileIdUpdate: (
      id: string,
      bannerTileId: string,
      data: UpdateBannerTileComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles/banner-tile-id/${bannerTileId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesBannerTileIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles/banner-tile-id/{banner_tile_id}
     */
    cmlAdminV1PagesIdComponentsBannerTilesBannerTileIdDetail: (
      id: string,
      bannerTileId: string,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles/banner-tile-id/${bannerTileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemsList
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles/banner-tile-id/{banner_tile_id}/items
     */
    cmlAdminV1PagesIdComponentsBannerTilesBannerTileIdItemsList: (
      id: string,
      bannerTileId: string,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileItemViewModelListSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles/banner-tile-id/${bannerTileId}/items`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannerTilesCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/banner-tiles
     */
    cmlAdminV1PagesIdComponentsBannerTilesCreate: (
      id: string,
      data: AddBannerTileComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerTileComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banner-tiles`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannersBannerIdItemsItemIdUpdate
     * @request PUT:/api/cml/admin/v1/pages/id/{id}/components/banners/banner-id/{banner_id}/items/item-id/{item_id}
     */
    cmlAdminV1PagesIdComponentsBannersBannerIdItemsItemIdUpdate: (
      id: string,
      bannerId: string,
      itemId: string,
      data: BannerItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banners/banner-id/${bannerId}/items/item-id/${itemId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannersBannerIdDetail
     * @request GET:/api/cml/admin/v1/pages/id/{id}/components/banners/banner-id/{banner_id}
     */
    cmlAdminV1PagesIdComponentsBannersBannerIdDetail: (
      id: string,
      bannerId: string,
      query?: {
        item_title?: string;
        /** @format date-time */
        item_from_date?: string;
        /** @format date-time */
        item_to_date?: string;
        item_display_status?: ComponentDisplayStatus;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BannerItemViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banners/banner-id/${bannerId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannersBannerIdItemCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/banners/banner-id/{banner_id}/item
     */
    cmlAdminV1PagesIdComponentsBannersBannerIdItemCreate: (
      id: string,
      bannerId: string,
      data: BannerItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banners/banner-id/${bannerId}/item`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Page
     * @name CmlAdminV1PagesIdComponentsBannersCreate
     * @request POST:/api/cml/admin/v1/pages/id/{id}/components/banners
     */
    cmlAdminV1PagesIdComponentsBannersCreate: (
      id: string,
      data: AddBannerComponentRequest,
      params: RequestParams = {},
    ) =>
      this.request<BannerComponentViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/pages/id/${id}/components/banners`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlV1PopUpElementsList
     * @request GET:/api/cml/v1/pop-up-elements
     */
    cmlV1PopUpElementsList: (
      query?: {
        /** @default false */
        isHomePage?: boolean;
        /** @format int32 */
        categoryId?: number;
        /** @format int32 */
        brandId?: number;
        /** @format int32 */
        tagId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPopUpElementViewModelSuccessEnvelop, any>({
        path: `/api/cml/v1/pop-up-elements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlV1HeaderElementsList
     * @request GET:/api/cml/v1/header-elements
     */
    cmlV1HeaderElementsList: (params: RequestParams = {}) =>
      this.request<GetHeaderElementViewModelSuccessEnvelop, any>({
        path: `/api/cml/v1/header-elements`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsPopUpPopUpIdPopUpIdUpdate
     * @request PUT:/api/cml/admin/v1/page-elements/pop-up/pop-up-id/{pop-up-id}
     */
    cmlAdminV1PageElementsPopUpPopUpIdPopUpIdUpdate: (
      popUpId: string,
      data: UpdatePopUpElementRequest,
      params: RequestParams = {},
    ) =>
      this.request<PopUpElementViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/pop-up/pop-up-id/${popUpId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsPopUpPopUpIdPopUpIdList
     * @request GET:/api/cml/admin/v1/page-elements/pop-up/pop-up-id/{pop-up-id}
     */
    cmlAdminV1PageElementsPopUpPopUpIdPopUpIdList: (
      popUpId: string,
      params: RequestParams = {},
    ) =>
      this.request<PopUpElementViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/pop-up/pop-up-id/${popUpId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsPopUpPopUpIdPopUpIdDelete
     * @request DELETE:/api/cml/admin/v1/page-elements/pop-up/pop-up-id/{pop-up-id}
     */
    cmlAdminV1PageElementsPopUpPopUpIdPopUpIdDelete: (
      popUpId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/pop-up/pop-up-id/${popUpId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsPopUpList
     * @request GET:/api/cml/admin/v1/page-elements/pop-up
     */
    cmlAdminV1PageElementsPopUpList: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
        title?: string;
        voucher_code?: string;
        business_type?: BusinessType;
        activation_status?: PageElementDisplayStatus;
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PopUpElementListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/page-elements/pop-up`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsPopUpCreate
     * @request POST:/api/cml/admin/v1/page-elements/pop-up
     */
    cmlAdminV1PageElementsPopUpCreate: (
      data: CreatePopUpElementRequest,
      params: RequestParams = {},
    ) =>
      this.request<PopUpElementViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/pop-up`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsHeaderHeaderIdHeaderIdUpdate
     * @request PUT:/api/cml/admin/v1/page-elements/header/header-id/{header-id}
     */
    cmlAdminV1PageElementsHeaderHeaderIdHeaderIdUpdate: (
      headerId: string,
      data: UpdateHeaderElementRequest,
      params: RequestParams = {},
    ) =>
      this.request<HeaderElementViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/header/header-id/${headerId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsHeaderHeaderIdHeaderIdDelete
     * @request DELETE:/api/cml/admin/v1/page-elements/header/header-id/{header-id}
     */
    cmlAdminV1PageElementsHeaderHeaderIdHeaderIdDelete: (
      headerId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/header/header-id/${headerId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsHeaderList
     * @request GET:/api/cml/admin/v1/page-elements/header
     */
    cmlAdminV1PageElementsHeaderList: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
        title?: string;
        activation_status?: PageElementDisplayStatus;
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        HeaderElementViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/page-elements/header`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageElement
     * @name CmlAdminV1PageElementsHeaderCreate
     * @request POST:/api/cml/admin/v1/page-elements/header
     */
    cmlAdminV1PageElementsHeaderCreate: (
      data: CreateHeaderElementRequest,
      params: RequestParams = {},
    ) =>
      this.request<HeaderElementViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/page-elements/header`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlpBanner
     * @name CmlV1PlpBannersList
     * @request GET:/api/cml/v1/plp-banners
     */
    cmlV1PlpBannersList: (
      query?: {
        cat_id?: string;
        tag_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPlpBannerViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/plp-banners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlpBanner
     * @name CmlAdminV1PlpBannersPlpBannerIdUpdate
     * @request PUT:/api/cml/admin/v1/plp-banners/plp-banner-id/{plp_banner_id}
     */
    cmlAdminV1PlpBannersPlpBannerIdUpdate: (
      plpBannerId: string,
      data: UpdatePlpBannerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlpBannerListViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/plp-banners/plp-banner-id/${plpBannerId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlpBanner
     * @name CmlAdminV1PlpBannersPlpBannerIdDelete
     * @request DELETE:/api/cml/admin/v1/plp-banners/plp-banner-id/{plp_banner_id}
     */
    cmlAdminV1PlpBannersPlpBannerIdDelete: (
      plpBannerId: string,
      params: RequestParams = {},
    ) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/plp-banners/plp-banner-id/${plpBannerId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlpBanner
     * @name CmlAdminV1PlpBannersList
     * @request GET:/api/cml/admin/v1/plp-banners
     */
    cmlAdminV1PlpBannersList: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 300
         * @default 10
         */
        page_size?: number;
        name?: string;
        is_published?: boolean;
        type?: PlpBannerType;
        cat_ids?: string[];
        tag_ids?: string[];
        /** @format date-time */
        starts_at?: string;
        /** @format date-time */
        ends_at?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PlpBannerListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/plp-banners`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlpBanner
     * @name CmlAdminV1PlpBannersCreate
     * @request POST:/api/cml/admin/v1/plp-banners
     */
    cmlAdminV1PlpBannersCreate: (
      data: CreatePlpBannerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlpBannerListViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/plp-banners`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Story
     * @name CmlV1StoriesList
     * @request GET:/api/cml/v1/stories
     */
    cmlV1StoriesList: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @min 1
         * @max 10
         * @default 10
         */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStoryListViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/stories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlV1TagsSlugDetail
     * @request GET:/api/cml/v1/tags/slug/{slug}
     */
    cmlV1TagsSlugDetail: (slug: string, params: RequestParams = {}) =>
      this.request<TagViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/tags/slug/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsIdSeoUpdate
     * @request PUT:/api/cml/admin/v1/tags/id/{id}/seo
     */
    cmlAdminV1TagsIdSeoUpdate: (
      id: number,
      data: UpdateSeoRequest,
      params: RequestParams = {},
    ) =>
      this.request<TagAdminViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/tags/id/${id}/seo`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsIdUpdate
     * @request PUT:/api/cml/admin/v1/tags/id/{id}
     */
    cmlAdminV1TagsIdUpdate: (
      id: number,
      data: UpdateTagRequest,
      params: RequestParams = {},
    ) =>
      this.request<TagAdminViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/tags/id/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsIdDetail
     * @request GET:/api/cml/admin/v1/tags/id/{id}
     */
    cmlAdminV1TagsIdDetail: (id: number, params: RequestParams = {}) =>
      this.request<TagAdminViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/tags/id/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsIdDelete
     * @request DELETE:/api/cml/admin/v1/tags/id/{id}
     */
    cmlAdminV1TagsIdDelete: (id: number, params: RequestParams = {}) =>
      this.request<SuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/tags/id/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsIdImportExcelCreate
     * @request POST:/api/cml/admin/v1/tags/id/{id}/import/_excel
     */
    cmlAdminV1TagsIdImportExcelCreate: (
      id: number,
      data: {
        /** @format binary */
        file?: File;
        /** @default false */
        include_first_row?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, FailureEnvelop>({
        path: `/api/cml/admin/v1/tags/id/${id}/import/_excel`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsSampleExcelList
     * @request GET:/api/cml/admin/v1/tags/sample/_excel
     */
    cmlAdminV1TagsSampleExcelList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/cml/admin/v1/tags/sample/_excel`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagProductsExcelList
     * @request GET:/api/cml/admin/v1/tag/products/_excel
     */
    cmlAdminV1TagProductsExcelList: (
      query?: {
        /** @format int32 */
        tag_id?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        TagListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/tag/products/_excel`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsExcelList
     * @request GET:/api/cml/admin/v1/tags/_excel
     */
    cmlAdminV1TagsExcelList: (
      query?: {
        title?: string;
        slug?: string;
        is_promotion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        TagListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/tags/_excel`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagsList
     * @request GET:/api/cml/admin/v1/tags
     */
    cmlAdminV1TagsList: (
      query?: {
        title?: string;
        slug?: string;
        is_promotion?: boolean;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 10000
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        TagListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/admin/v1/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tag
     * @name CmlAdminV1TagCreate
     * @request POST:/api/cml/admin/v1/tag
     */
    cmlAdminV1TagCreate: (data: AddTagRequest, params: RequestParams = {}) =>
      this.request<TagAdminViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/admin/v1/tag`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name CmlV1VideosShortVideoList
     * @request GET:/api/cml/v1/videos/short-video
     */
    cmlV1VideosShortVideoList: (
      query?: {
        product_slug?: string;
        category_ids?: number[];
        labels?: string[];
        slug?: string;
        /**
         * @format int32
         * @default 1
         */
        page_number?: number;
        /**
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        GetShortVideoListViewModelPaginationViewModelSuccessEnvelop,
        FailureEnvelop
      >({
        path: `/api/cml/v1/videos/short-video`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name CmlV1VideosShortVideoSlugDetail
     * @request GET:/api/cml/v1/videos/short-video/slug/{slug}
     */
    cmlV1VideosShortVideoSlugDetail: (
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<GetShortVideoViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/videos/short-video/slug/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name CmlV1VideosShortVideoGetTokenDetail
     * @request GET:/api/cml/v1/videos/short-video/get-token/{slug}
     */
    cmlV1VideosShortVideoGetTokenDetail: (
      slug: string,
      query?: {
        ut?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShortTokenViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/videos/short-video/get-token/${slug}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name CmlV1VideosShortVideoLabelsList
     * @request GET:/api/cml/v1/videos/short-video/labels
     */
    cmlV1VideosShortVideoLabelsList: (params: RequestParams = {}) =>
      this.request<GetShortLabelListViewModelSuccessEnvelop, FailureEnvelop>({
        path: `/api/cml/v1/videos/short-video/labels`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name CmlV1VideosShortVideoCategoriesList
     * @request GET:/api/cml/v1/videos/short-video/categories
     */
    cmlV1VideosShortVideoCategoriesList: (params: RequestParams = {}) =>
      this.request<GetShortCategoryListViewModelSuccessEnvelop, FailureEnvelop>(
        {
          path: `/api/cml/v1/videos/short-video/categories`,
          method: "GET",
          format: "json",
          ...params,
        },
      ),
  };
  sitemap = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapList
     * @request GET:/sitemap
     */
    sitemapList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/sitemap`,
        method: "GET",
        ...params,
      }),
  };
  sitemapXml = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapXmlList
     * @request GET:/sitemap.xml
     */
    sitemapXmlList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/sitemap.xml`,
        method: "GET",
        ...params,
      }),
  };
  nameSitemapNumber = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapDetail
     * @request GET:/{name}-sitemap-{number}
     */
    sitemapDetail: (name: string, number: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/${name}-sitemap-${number}`,
        method: "GET",
        ...params,
      }),
  };
  nameSitemapNumberXml = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapXmlList
     * @request GET:/{name}-sitemap-{number}.xml
     */
    sitemapXmlList: (
      name: string,
      number: number,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/${name}-sitemap-${number}.xml`,
        method: "GET",
        ...params,
      }),
  };
  nameSitemap = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapList
     * @request GET:/{name}-sitemap
     */
    sitemapList: (
      name: string,
      query?: {
        /**
         * @format int32
         * @default 1
         */
        number?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/${name}-sitemap`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  nameSitemapXml = {
    /**
     * No description
     *
     * @tags Sitemap
     * @name SitemapXmlList
     * @request GET:/{name}-sitemap.xml
     */
    sitemapXmlList: (
      name: string,
      query?: {
        /**
         * @format int32
         * @default 1
         */
        number?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/${name}-sitemap.xml`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
}
